import React from "react";
import { Stack } from "@datanomik/commons-ui";
import { SendMoney } from "@datanomik/commons-ui/icons";
import { useTranslation } from "react-i18next";
import AnimatedEntrance from "@/views/common/AnimatedEntrance";
import { CashPoolingBreadcrumbs } from "../../components/CashPoolingBreadcrumbs/CashPoolingBreadcrumbs";
import { RuleCreationPageLayout } from "../RuleCreationPageLayout";
import { RuleCreationTypeSelector } from "./RuleCreationTypeSelector";
import { useRuleCreationTypeSelector } from "./useRuleCreationTypeSelector";

/**
 * RuleCreationTypeSelectorPage component
 *
 * Page wrapper for selecting the type of cash pooling rule to create.
 * Uses AnimatedEntrance and RuleCreationPageLayout for consistent UI.
 *
 * Route: /cash-pooling/rule-creation
 */
export const RuleCreationTypeSelectorPage: React.FC = () => {
  const { t } = useTranslation();
  const { onSelectExcessRule, onSelectMinimumRule, onSelectRecurrenceRule } =
    useRuleCreationTypeSelector();

  return (
    <AnimatedEntrance>
      <Stack
        spacing={3}
        sx={{
          maxWidth: "900px",
          width: "100%",
          margin: "0 auto",
          px: 4,
          py: 4,
        }}
      >
        <CashPoolingBreadcrumbs
          items={[
            { label: "Cash Pooling", path: "/cash-pooling", params: { tab: "regras" } },
            {
              label: t("Rule Creation"),
              path: "/cash-pooling/rule-creation",
            },
          ]}
        />

        <RuleCreationPageLayout
          header={t("Select the balance rule type")}
          subheader={t("Automate transfers based on your account balance.")}
          icon={<SendMoney />}
        >
          <RuleCreationTypeSelector
            onSelectExcessRule={onSelectExcessRule}
            onSelectMinimumRule={onSelectMinimumRule}
            onSelectRecurrenceRule={onSelectRecurrenceRule}
          />
        </RuleCreationPageLayout>
      </Stack>
    </AnimatedEntrance>
  );
};
